import {SelectDefaultPeriodType} from "../interfaces/enums/SelectDefaultPeriodType.enum";

export const dateHelpers = {

    dayInMiliseconds: 86400000,

    getDefaultDate(days: number): Date {
        let currentDate = new Date();
        currentDate.setDate(currentDate.getDate() + days);

        return currentDate;
    },

    dateToDisplay: function(date: Date): string {
        return `${date.getFullYear()}-${date.getMonth() < 9 ? '0' : ''}${date.getMonth() + 1}-${date.getDate() < 10 ? '0' : ''}${date.getDate()}`;
    },

    dateTimeToDisplay: function(date: Date): string {
        const dateFull = `${date.getFullYear()}-${date.getMonth() < 9 ? '0' : ''}${date.getMonth() + 1}-${date.getDate() < 10 ? '0' : ''}${date.getDate()}`;
        const timeFull = `${date.getHours() < 10 ? '0' : ''}${date.getHours()}:${date.getMinutes() < 10 ? '0' : ''}${date.getMinutes()}`;

        return dateFull + ' ' + timeFull;
    },

    calculateEndDate(startDate: Date, y: number, m: number, d: number): Date {
        return new Date(startDate.getFullYear() + y, startDate.getMonth() + m, startDate.getDate() + d);
    },

    plusMonth(date: Date, index: number, period: number): Date {
        let m = new Date(date);
        m.setMonth(m.getMonth() + 1 * index * period);
        return m;
    },

    plusYear(date: Date, index: number, period: number): Date {
        let y = new Date(date);
        y.setFullYear(y.getFullYear() + 1 * index * period);
        return y;
    },

    plusDurationMonthYear(
        mainInterval: number,
        start: Date,
        end: Date,
        period: number,
        callback: Function
    ): Array<Date> {

        let newDates: Array<Date> = [];

        for (let i = 0; i < mainInterval; i++) {
            const newDate = callback(start, i, period);
            if (new Date(newDate).getTime() < new Date(end).getTime()) {
                newDates.push(newDate);
            }
        }

        return newDates;
    },

    plusDurationDayWeek(
        mainInterval: number,
        start: Date,
        end: Date,
        period: number,
        multiplier: number
    ): Array<Date> {

        let newDates: Array<Date> = [];

        for (let i = 0; i < mainInterval; i++) {
            const newDate = new Date(start.getTime() + i * this.dayInMiliseconds * multiplier * period);
            if (newDate.getTime() < end.getTime()) {
                newDates.push(new Date(newDate));
            }
        }

        return newDates;
    },

    calculateAllDates(period: number, dates: Array<Date>, endDate: Date, multiplier: number, selectedPeriodType: string): Array<Date> {
        let result: Array<Date> = [];

        for (const date of dates) {
            let tempArr = this.calculateDates(period, date, endDate, multiplier, selectedPeriodType);
            result.push(...tempArr);
        }

        return result;
    },

    calculateDates(
        period: number,
        date: Date,
        endDate: Date,
        multiplier: number,
        selectedPeriodType: string
    ): Array<Date> {
        // INIT DEADLINE, START, END
        let newDates: Array<Date> = []
        let deadline = 0
        let mainInterval;
        let start: any = new Date(date.toDateString());
        let end: any = new Date(endDate.toDateString());

        switch (selectedPeriodType) {
            case SelectDefaultPeriodType.DAY:
                deadline = Math.ceil(end - start) / this.dayInMiliseconds;
                mainInterval = Math.round(deadline / period);

                newDates = this.plusDurationDayWeek(mainInterval, start, end, period, multiplier);

                break
            case SelectDefaultPeriodType.WEEK:
                deadline = Math.ceil(end - start) / this.dayInMiliseconds;
                mainInterval = Math.round(deadline / (period * multiplier));

                newDates = this.plusDurationDayWeek(mainInterval, start, end, period, multiplier);

                break
            case SelectDefaultPeriodType.MONTH:
                deadline = Math.ceil(end.getMonth() - start.getMonth() + 12 * (end.getFullYear() - start.getFullYear()));
                mainInterval = Math.ceil(deadline / period);

                newDates = this.plusDurationMonthYear(mainInterval, start, end, period, this.plusMonth);

                break
            case SelectDefaultPeriodType.YEAR:
                deadline = end.getFullYear() - start.getFullYear();
                mainInterval = Math.ceil(deadline / period);

                newDates = this.plusDurationMonthYear(mainInterval, start, end, period, this.plusYear);

                break
            default:
                break
        }
        return newDates;
    },

    getDatesOfSelectedDays(
        selectedDays: Array<number>,
        weekDays: Array<{id: number, name: string, date: Date}>
    ): Array<Date> {
        let needDays: Array<Date> = [];

        for (const selectedDay of selectedDays) {
            let temp: Array<Date>  = weekDays.filter((el) => el.id === selectedDay).map(el => el.date);
            needDays.push(...temp);
        }

        return needDays;
    },


    calculateAllNthDays(
        date: Date,
        endDate: Date,
        nthDay: number,
        day: number
    ): Array<Date> {

        let start = new Date(date.toDateString());
        let interval = endDate.getMonth() - start.getMonth() + 12 * (endDate.getFullYear() - start.getFullYear());
        let calculatedDays: Array<Array<{date: Date, day: number}>> = [];

        for (let i = 0; i < interval; i++) {

            let fullDate = new Date(start.getFullYear(), start.getMonth() + i, start.getDate());
            let month = new Date(start.getFullYear(), start.getMonth() + i, start.getDate()).getMonth();
            let daysCount = new Date(start.getFullYear(), start.getMonth() + i + 1, 0).getDate();

            let tempArr: Array<{date: Date, day: number}> = [];

            for (let j = 0; j < daysCount; j++) {
                if (new Date(fullDate.getFullYear(), month, j + 1).getDay() === day) {
                    tempArr.push({
                        date: new Date(fullDate.getFullYear(), month, j + 1),
                        day: new Date(fullDate.getFullYear(), month, j + 1).getDay()
                    });
                }
            }
            calculatedDays.push(tempArr);
        }

        if (nthDay === 4) {
            return calculatedDays.map((el) => el[nthDay]).filter(el => el !== undefined).map(el => el.date);
        }

        return calculatedDays.map((el) => el[nthDay].date);
    },

    calculateNthSelectedDay(date: Date): number {

        let start = new Date(date.toDateString());
        let daysCount = new Date(start.getFullYear(), start.getMonth() + 1, 0).getDate();
        let monthDaysArr: Array<{date: Date, day: number}>  = [];
        let index = 0;

        for (let j = 0; j < daysCount; j++) {
            if (new Date(start.getFullYear(), start.getMonth(), j + 1).getDay() === start.getDay()) {
                monthDaysArr.push({
                    date: new Date(start.getFullYear(), start.getMonth(), j + 1),
                    day: new Date(start.getFullYear(), start.getMonth(), j + 1).getDay()
                })
            }
        }

        for (let i = 0; i < monthDaysArr.length; i++) {
            if (monthDaysArr[i].date.getTime() === start.getTime()) {
                index = i;
            }
        }

        return index;
    },

    /**
     *
     * @param forwardDate
     * @param backDate
     * @return number
     * difference converted in days
     */
    differenceBetweenTwoDates(forwardDate: Date, backDate: Date): number {
        let back = new Date(backDate!.getFullYear(), backDate!.getMonth(), backDate!.getDate());
        let forward = new Date(forwardDate!.getFullYear(), forwardDate!.getMonth(), forwardDate!.getDate());

        return (+back - +forward) / (1000 * 60 * 60 * 24);
    }
}